<template>
  <div class="trm-card">
    <div class="mdn-Row">
      <div class="mdn-Col-lg">
        <span :class="icon"></span>
      </div>
    </div>
    <div class="mdn-Row">
      <div class="mdn-Col-lg">
        <p class="mdn-Text titulo">
          <b>{{ titulo }}</b>
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";

import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "CardSmall",
})
export default class CardSmall extends Vue {
  @Prop({ default: "" }) readonly titulo!: string;

  @Prop({ default: "" }) readonly icon!: string;
}
</script>
